import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { useDropzone } from "react-dropzone-with-hooks";

// This component is mainly a wrapper for the React-Dropzone filedropper component
// It doesn't have a lot of opinions about the behavior of the dropper in the wild, just an onFileAdded callback.
// You need to pass in the innards with the contextual messaging.

const propTypes = {
  children: PropTypes.element,
  containerClassName: PropTypes.string,
  onFileAdded: PropTypes.func,
  ref: PropTypes.oneOfType([
    // Either a function
    PropTypes.func,
    // Or the instance of a DOM native element (see the note about SSR)
    PropTypes.shape({ current: PropTypes.instanceOf(Element) })
  ])
};

export default function FileDrop(props) {
  const { children, containerClassName, onFileAdded, ref } = props;
  const onDrop = useCallback(acceptedFiles => {
    onFileAdded(acceptedFiles);
  }, []);
  const { getRootProps, getInputProps } = useDropzone({ onDrop });
  return (
    <span {...getRootProps()} className={containerClassName} ref={ref}>
      <input {...getInputProps()} />
      {children}
    </span>
  );
}

FileDrop.propTypes = propTypes;
